import { PageContent, PageHeader, Tab, Tabs } from "components/layout";
import { RestrictedArea, ALL_MODERATORS } from "containers/Permissions";
import { useRouter } from "hooks/utils";
import { trans } from "src/translations";

import { ManifestData } from "../ManifestData";
import { getDetailsPath } from "../utils";
import { ManifestChangelogTab } from "./ManifestChangelogTab";
import { ManifestSummaryTab } from "./ManifestSummaryTab";

const TABS = [
  { path: "details", text: "Manifest", dataTestId: "details" },
  { path: "history", text: "History", dataTestId: "history" },
];

export const ManifestDetails = () => {
  const { params, navigate } = useRouter();
  const { id, tabId } = params;

  const getTabs = () =>
    TABS.map((tab, idx) => {
      return (
        <Tab
          key={tab.path}
          active={getActiveTab() === idx}
          text={tab.text}
          dataTestId={tab.dataTestId}
          onClick={() => {
            navigate(getDetailsPath(id!, tab.path));
          }}
        />
      );
    });

  const getActiveTab = () => TABS.findIndex(({ path }) => path === tabId);

  return (
    <>
      <PageHeader>{trans.APP_MANIFESTS_DETAILS_PAGE_HEADER()}</PageHeader>
      <PageContent>
        <RestrictedArea allowed={ALL_MODERATORS}>
          <Tabs>{getTabs()}</Tabs>
          <ManifestData id={id}>
            {getActiveTab() === 0 && <ManifestSummaryTab />}
            {getActiveTab() === 1 && <ManifestChangelogTab />}
          </ManifestData>
        </RestrictedArea>
      </PageContent>
    </>
  );
};
